import React,{useEffect, useState} from "react";
import {getorganizationData,setorganizationData} from "../../../redux/actions/dataAction"
import {connect} from 'react-redux'
import CustomHeading from "../../../constants/CustomHeading";
import CustomInput from '../../../constants/CustomInput'
import CustomButton from "../../../constants/CustomButton";
import CustomRichTextField from "../../../constants/CustomRichTextField";




const Organization = (props) => {
  const [name,setName]=useState('');
  const [society_name,setSocityName]=useState('');
  const [description,setDescription]=useState('');
  const [mission,setMission]=useState('');
  const [vision,setVision]=useState('');
  const [isLoading,setIsLoading]=useState(false);
  useEffect(()=>{
    props.getorganizationData();
  },[])
  const handleSubmit=(e)=>{
    e.preventDefault();
    setIsLoading(true);
    const organization=props?.organization;
    const data={
      ...organization,
      name: name!==''?name:organization?.name,
      description: description!==''?description:organization?.description,
      society_name: society_name!==''?society_name:organization?.society_name,
      mission:mission!==''?mission:organization?.mission,
      vision:vision!==''?vision:organization?.vision,
      updated_at: new Date().toString(),
    }
    console.log(data);
    props.setorganizationData(data);
    setIsLoading(false);
    

  }
 console.log(props?.organization)
  return (
    <>
        <div className='customContainer'>
        <CustomHeading title="Organization"/>
        <form onSubmit={handleSubmit} style={{marginTop:0}}>
        <CustomInput
          type={'text'}
          id="society_name"
          label={'Society Name :'}
          placeholder={'Enter Society Name'}
          value={props?.organization?.society_name}
          onChange={(e)=>setSocityName(e.target.value)}
        />
        <CustomInput
          type={'text'}
          id="name"
          label={'Organization Name :'}
          placeholder={'Enter Organization Name'}
          value={props?.organization?.name}
          onChange={(e)=>setName(e.target.value)}
        />
        <CustomRichTextField
          label={'Description :'}
          value={props?.organization?.description}
          id="description"
          onChange={(value)=>{setDescription(value)
          }}
        />
        <div className="mt-3"/>
        <CustomInput
          type={'text'}
          id="mission"
          label={'Mission :'}
          placeholder={'Enter Mission'}
          value={props?.organization?.mission}
          onChange={(e)=>setMission(e.target.value)}
        />

        <CustomInput
          type={'text'}
          id="vision"
          label={'Vision :'}
          placeholder={'Enter Vision'}
          value={props?.organization?.vision}
          onChange={(e)=>setVision(e.target.value)}
        />
        
        <CustomButton
          label={'Save'}
          isIcon
          isloading={isLoading}
           />
   
      </form>
        
        </div>
        

    </>
  );
};


const mapActionWithProps = {
  getorganizationData,
  setorganizationData
}
const mapStateWithProps = (state)=>(

  {
    
    organization:state.data.organisation.data
  }
  )
export default connect(mapStateWithProps,mapActionWithProps)(Organization);